var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("base-table", {
        ref: "table",
        attrs: {
          loading: _vm.listLoading,
          "table-data": _vm.tableData,
          columns: _vm.tableColumns,
          showSelection: _vm.showSelection,
          pagination: {
            pageNum: _vm.tableFrom.page,
            pageSize: _vm.tableFrom.limit,
          },
          "checked-list": _vm.checkedList,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.pageChange,
          "switch-change": _vm.onchangeIsShow,
          "selection-change": _vm.selectionChange,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "number",
              fn: function (ref) {
                var row = ref.row
                var index = ref.index
                return [
                  !row.isLimited
                    ? _c("span", [_vm._v("不限量")])
                    : _c("div", [
                        _c("div", { staticClass: "fa" }, [
                          _vm._v("发布：" + _vm._s(row.total)),
                        ]),
                        _c("div", { staticClass: "sheng" }, [
                          _vm._v("剩余：" + _vm._s(row.lastTotal)),
                        ]),
                      ]),
                ]
              },
            },
            {
              key: "operate",
              fn: function (ref) {
                var row = ref.row
                var index = ref.index
                return [_vm._t("operate", null, { row: row, index: index })]
              },
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }